import React from 'react';

import PDFViewer from '../../components/PDFViewer';
import pdfFile_ro from '../../assets/PDF/personal_data_policy_ro.pdf';
import pdfFile_ru from '../../assets/PDF/personal_data_policy_ru.pdf';

const PersonalDataPolicy: React.FC<{}> = () => {
    return (
        <PDFViewer
            pdfFileRo={pdfFile_ro}
            pdfFileRu={pdfFile_ru}
        />       
    )
}

export default PersonalDataPolicy;